<template>
    <div>
        <!--<nav-back :dataTit="'相册'"></nav-back>-->
        <!--<def-hn></def-hn>-->
        <div class="album-one" v-if="oneShow" :style="'min-height: ' + screenHeight + 'px'">
            <div class="bonts">
                <div class="bonts-del" @click="del">删除</div>
                <div @click="oneShow = false">关闭</div>
            </div>
            <img class="album-one-img" :src="checkUrl"/>
            <div class="share-container">
                <img  src="../../assets/common/peng.png"/>
                <div @click="goyanzheng">分享至朋友圈吧~</div>
            </div>
        </div>
        <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" v-else>
            <div class="frame-ul cont-width">
                <div class="frame-one" v-for="(item, index) in list" :key="index" @click="checkFrame(item)">
                    <img :src="item.mix_pic"/>
                </div>
            </div>
        </mt-loadmore>
        <div class="no-msg" v-if="nomsgShow">暂无数据</div>
        <share :isShow="shareShow" @showfalse="shareShow = false" :isUrl="isUrl"></share>
    </div>
</template>


<script>
  import { Toast, MessageBox } from 'mint-ui'
  import NavBack from "../public/navBack"
  import DefHn from "../public/defHn"
  import config from '../../common/config.js'
  import Share from "../public/share"

  export default {
    name: "album",
    components: {
      Share,
      NavBack, DefHn},
    data () {
      return {
        list: [],
        pages: 1,
        allLoaded: false,
        oneShow: false,
        checkUrl: '',
        checkId: '',
        nomsgShow: false,
        videoWidth: '',
        videoHeight: '',
        screenHeight: '',
        shareShow: false,
        isUrl: ''
      }
    },
    mounted () {
      // WeixinJSBridge.call('showOptionMenu');
      this.getAll()
      document.body.parentNode.style.overflow = "auto"
      this.screenHeight = window.screen.height
    },
    watch: {
      oneShow () {
        if (this.oneShow) {
          window.scrollTo(0, 0)
          document.body.parentNode.style.overflow = "hidden"
        } else {
          document.body.parentNode.style.overflow = "auto"
        }
      }
    },
    methods: {
      del () {
        let that = this
        MessageBox.confirm('确认删除？').then(action => {
          this.$g.ajax({
            method: 'post',
            path: 'userAlbums/delete',
            data: {
              id: that.checkId
            },
            cbSuccess(data) {
              Toast({
                message: '删除成功',
                position: 'bottom',
                duration: 1000
              })
              location.reload()
            },
            cbError(data) {
              let msg = data.msg
              Toast({
                message: msg,
                position: 'bottom',
                duration: 1000
              })
            }
          })
        })
      },
      checkFrame (i) {
        this.isUrl = 'photo/browse?imgurl=' + i.mix_pic + '&eid=' + this.$route.query.eid
        this.checkUrl = i.mix_pic
        this.checkId = i.id
        this.oneShow = true
      },
      getAll () {
        let that = this
        this.$g.ajax({
          method: 'post',
          path: 'userAlbums/getList',
          data: {
            event_id: this.$route.query.eid,
            page: this.pages
          },
          cbSuccess(data) {
            that.$refs.loadmore.onTopLoaded()
            that.$refs.loadmore.onBottomLoaded();
            for (let i in data.memo.list) {
              that.list.push(data.memo.list[i])
            }
            if (that.list.length <= 0) {
              that.nomsgShow = true
            }
          },
          cbError(data) {
            let msg = data.msg
            Toast({
              message: msg,
              position: 'bottom',
              duration: 1000
            })
          }
        })
      },
      loadTop () {
        this.list = []
        this.pages = 1
        this.getAll()
      },
      loadBottom () {
        this.pages++
        this.getAll()
      },
      // 分享
      goyanzheng () {
        this.shareShow = true
      }
    }
  }
</script>

<style lang="scss" scoped>
    .frame-ul{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 10px;
        overflow-y: auto;
        .frame-one{
            width: 45%;
            border: 1px solid #ccc;
            text-align: center;
            line-height: 50%;
            padding: 10px 0;
            margin-bottom: 20px;
            img{
                width: 50%;
            }
        }
    }
    .album-one{
        background-color: #000000;
        color: #fff;
        .bonts{
            padding: 10px 16px;
            text-align: right;
            display: flex;
        }
        .bonts-del{
            margin-right: 14px;
        }
        .album-one-img{
            width: 100%;
        }
        .share-container{
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            height: 62px;
            background-color: #999999;
            display: flex;
            justify-content: center;
            img{
                width: 50px;
                height: 50px;
                margin-top: 4px;
            }
            div{
                color: #ffffff;
                font-size: 20px;
                margin-top: 16px;
                margin-left: 4px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/album/index.vue